import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Adresse, ChoixDocumentation, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useUrlReturn, useSubmission } from "hooks"
import { adresse, consent, consentement, defaultValues, getAcademicLevels, salutations } from "services"
import MentionsLegales from "components/MentionsLegales"

const Form = () => {
  const { recordTypeId, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('IA-INST-DOC')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement,
        ...adresse,
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const defaultDataLead = {
      Campus__c: 'Paris',
      Division__c: 'EPITA IA Institut',
      IONISSchool__c: 'EPITA IA Institut',
      LastForm__c: 'Documentation PDF',
      LeadSource: 'Internet: Demande de doc',
      Paper_doc_request__c: choix === 'recevoir',
      PDFdownloaded__c: choix === 'telecharger',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}

    // Appel du hook de soumission (flowInterview)
    try {
      await submission({
        formId: 'DOC',
        lead: finalLead,
        // campaignId: undefined,
        // campaignStatus: undefined,
        utmCookieName: '_ionis_user_data' // optionnel
      })
      document.location.href=`${url}?niveau=${encodeURIComponent(lead.AcademicLevel__c)}`
    } catch (e) {
      setError("Une erreur est survenue lors de l'envoi", e?.message || String(e))
    }

    return false
  }
  // Watch
  const choix = watch('choix')
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <ChoixDocumentation />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={getAcademicLevels('EPITA IA Institut')} school="EPITA IA Institut" section={false} specialites={false} />
        {choix === 'recevoir' && (
          <Adresse />
        )}
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="EPITA IA Institut" />
      </Grid>
    </FormProvider>
  )
}

export default Form
